import { render } from "./EntityTypeSelector.vue?vue&type=template&id=55595bcc"
import script from "./EntityTypeSelector.vue?vue&type=script&lang=js"
export * from "./EntityTypeSelector.vue?vue&type=script&lang=js"
script.render = render

export default script